import http from './http'
import Loader from './loader'
import Partial from './partial'
import Scroll from './scroll'

export default class LoadPartials {
    constructor (el, targetEl, action = false, event = 'click', customLoader = null, allowClose = false, scrollToLoadedContent = false) {
        this.el = el
        this.targetEl = targetEl
        this.allowClose = allowClose
        this.action = action
        this.loader = customLoader ? new customLoader(this.el) : new Loader(this.el)
        this.partial = null
        this.scrollToLoadedContent = scrollToLoadedContent

        if (event === 'instant') {
            this.submitHandler()
        } else {
            this.el.addEventListener(event, (e) => {
                e.preventDefault()
                this.submitHandler()
            })
        }
    }

    async submitHandler () {
        if (this.el.dataset.loaded) {
            return
        }

        if (this.allowClose) {
            if (this.partial && this.partial.isVisible()) {
                return
            }
            document.dispatchEvent(new Event('partials_close'))
        }

        try {
            this.loader.start()
            const data = this.el.dataset
            const response = await http.post(this.action, data)
            if (response.status === 200) {
                this.loader.stop()
                if (this.allowClose) {
                    this.partial = new Partial(response.data)
                    const el = this.partial.getElement();
                    if (this.targetEl) {
                        this.targetEl.appendChild(el)
                    } else {
                        this.el.insertAdjacentElement('afterend', el)
                    }
                    if (this.scrollToLoadedContent) {
                        Scroll.scrollToEl(el, typeof this.scrollToLoadedContent === 'object' ? this.scrollToLoadedContent : {})
                    }
                } else {
                    if (this.targetEl) {
                        this.targetEl.innerHTML = response.data
                    } else {
                        this.el.insertAdjacentHTML('afterend', response.data)
                    }
                    this.el.dataset.loaded = true
                }
                document.dispatchEvent(new Event('partials_loaded'))
            }
        } catch (error) {
            this.loader.stop()
        }
    }
}